export const EVENT = {
    ClientDeviceMfaValidated: 'Client Device MFA Validated',
    ClientIdentityInstructionsViewed: 'Client Identity Instructions Viewed',
    ClientIdentityStarted: 'Client Identity Started',
    ClientIdentityDocTypeSelected: 'Client Identity Doc Type Selected',
    ClientKbaPrimed: 'Client KBA Primed',
    ClientKbaQuestionsRetrieved: 'Client KBA Questions Retrieved',
    ClientKbaAnswersValidated: 'Client KBA Answers Validated',
    ClientFullKycStarted: 'Client Payment KYC Started',
    ClientFullKycCompleted: 'Client Payment KYC Completed',
};
